import {FC} from 'react';
import './Footer.css';

const Footer: FC = () => (
  <>
      <span>&copy; {new Date().getFullYear()}</span>
      <span> Software de Administración </span>
      <a target={'_blank'} rel="noreferrer" href={'https://haikanetwork.com/'}>Haika Network, Inc.</a>
      <span> Todos los derechos reservados.</span>
  </>
);

export default Footer;
